import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DataSection } from '@app/shared/models/data-section';

@Component({
    selector: 'sl-data-section',
    template: `
		<div class="row">
			<div class="linq-key-value col-12 col-xs-3 linq-my-3" *ngFor="let element of data">
				<h6 class="linq-key-value__key">{{ element.title }}</h6>
				<span class="linq-key-value__value">{{ element.data }}</span>
			</div>
		</div>
	`,
    standalone: true,
    imports: [NgFor],
})
export class DataSectionComponent {
	@Input() data: DataSection[];

	constructor() {}
}
